import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import MenuIcon from "@mui/icons-material/Menu";
import { FiSearch } from "react-icons/fi";
import navbarClasses from "../Navbar.module.css";
import SearchBox from "../Search box/SearchBox";

export default function LanCurrSelect({ toggle, isSearchBar, setIsSearchBar }) {
  return (
    <div style={{ display: 'flex', flexDirection: "row", gap: "1em", width: '100%' }}>
      <div style={{ width: 'fit-content', height: 'fit-content', margin: 'auto 0', padding: '.1em' }} onClick={toggle}>
        <Tooltip title="menu">
          <IconButton sx={{ p: 0 }}>
            <MenuIcon
              style={{
                width: "30px",
                height: "30px",
                color: "var(--secondary-color)",
                margin: "0",
              }} />
          </IconButton>
        </Tooltip>
      </div>

      {isSearchBar ? (
        <div
          className={navbarClasses.icon}
          style={{ width: "40px", height: "40px", borderRadius: "50%", margin: 'auto 0' }}
        >
          <IconButton
            sx={{ p: 0 }}
            onClick={() => {
              setIsSearchBar(true);
            }}
          >
            <FiSearch
              style={{
                width: "30px",
                height: "30px",
                color: "var(--secondary-color)",
                margin: "6px",
              }} />
          </IconButton>
        </div>
      ) : (
        <div className={navbarClasses.search_con}>
          <SearchBox setIsSearchBar={setIsSearchBar} isSearchBar={isSearchBar} />
        </div>
      )}
    </div>
  );
}
